<template>
  <FpvReportsTable
    :fpv-reports="approvedFpvReports"
    :is-preview="false"
    :refresh-function="refreshTable"
    :loading="loading"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { toQueryString } from '@/helpers';
import FpvReportsTable from '@/components/roboInvesting/FpvReportsTable';

export default {
  name: 'ApprovedFpvReportsTab',
  components: {
    FpvReportsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.fpvReportsStore.approvedLoading,
      approvedFpvReports: state => state.fpvReportsStore.approvedFpvReports,
    }),
  },
  mounted() {
    this.getApprovedFpvReports();
  },
  methods: {
    ...mapActions(['getApprovedFpvReports']),
    refreshTable(search) {
      const query = toQueryString({
        userId: search,
      });
      if (typeof window.LIT !== 'undefined') {
        clearTimeout(window.LIT);
      }
      window.LIT = setTimeout(() => {
        this.getApprovedFpvReports(query);
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/roboInvesting/ApprovedFpvReportsTab.vue